<template>
  <v-app id="inspire">
    <v-content class="register-frame">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 ml-5" style="margin-top:80px">
              <v-toolbar color="#A7C84B" dark flat>
                <v-toolbar-title>Regístrate</v-toolbar-title>
                <v-spacer />
                <v-toolbar-title>
                  <router-link :to="{ name: 'landingPage' }">
                    <v-img
                      :src="require('@/assets/ObiPetsLogo.svg')"
                      class="my-3"
                      contain
                      height="50"
                    />
                  </router-link>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form>
                  <form-wrapper :validator="$v.form">
                    <div style="margin-bottom: 20px">
                      <form-summary />
                    </div>

                    <form-group name="name">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          type="text"
                          outlined
                          v-bind="attrs"
                          append-icon="mdi-account"
                          v-model="form.name"
                          hint="4 caracteres requeridos"
                          label="Nombre"
                          @input="$v.form.name.$touch()"
                        />
                      </template>
                    </form-group>

                    <form-group name="lastname">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          type="text"
                          outlined
                          v-bind="attrs"
                          append-icon="mdi-account"
                          v-model="form.lastname"
                          hint="4 caracteres requeridos"
                          label="Apellido"
                          @input="$v.form.lastname.$touch()"
                        />
                      </template>
                    </form-group>

                    <form-group name="email">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          type="email"
                          outlined
                          v-bind="attrs"
                          v-model="form.email"
                          append-icon="mdi-at"
                          label="E-mail"
                          @input="toLowerCas()"
                        />
                      </template>
                    </form-group>

                    <form-group name="DateVal">
                      <label for=""> Fecha de nacimiento</label>
                      <div class="d-flex">
                        <v-select
                          :success="dia == '' ? false : true"
                          v-model="dia"
                          style="margin:5px;"
                          outlined
                          :items="dias"
                          label="Dia"
                        ></v-select>
                        <v-select
                          :success="mes == '' ? false : true"
                          v-model="mes"
                          style="margin:5px;"
                          outlined
                          :items="meses"
                          label="Mes"
                        ></v-select>
                        <v-select
                          :success="ano == '' ? false : true"
                          v-model="ano"
                          style="margin:5px;"
                          outlined
                          :items="anos"
                          label="Año"
                        ></v-select>
                      </div>
                    </form-group>

                    <form-group name="passwod">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          :success="pasSucces"
                          :error="pasError"
                          outlined
                          v-bind="attrs"
                          v-model="form.password"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          name="input-10-1"
                          label="Contraseña"
                          hint="8 caracteres requeridos"
                          @input="$v.form.password.$touch()"
                          counter
                          @click:append="show1 = !show1"
                        />
                      </template>
                    </form-group>
                    <form-group name="repeatPasswod">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          :success="pasRepSucces"
                          :error="pasRepError"
                          outlined
                          v-bind="attrs"
                          v-model="form.repeatPassword"
                          :type="show1 ? 'text' : 'password'"
                          label="Repite la contraseña"
                          @input="$v.form.repeatPassword.$touch()"
                        />
                      </template>
                    </form-group>
                    <form-group name="phone" style="margin:-15px 0 20px 0">
                      <template slot-scope="{ attrs }">
                        <vue-phone-number-input
                          size="lg"
                          v-model="form.phone"
                          :no-example="false"
                          v-bind="attrs"
                          @update="onUpdate"
                          :only-countries="['MX', 'CO', 'GT', 'HN', 'SV', 'NI','CA','US']"
                          :translations="{
                            countrySelectorLabel: 'Codigo de país',
                            countrySelectorError: 'Elige un pais',
                            phoneNumberLabel: 'Numéro de celular',
                            example: 'Ejemplo :',
                          }"
                        />
                      </template>
                    </form-group>
                    <form-group name="codeValidation">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          autocomplete="off"
                          type="text"
                          :disabled="codigoSend"
                          outlined
                          v-bind="attrs"
                          v-model="form.codeValidation"
                          append-icon="mdi-message-alert"
                          label="Código SMS"
                          @input="$v.form.codeValidation.$touch()"
                        />
                      </template>
                    </form-group>
                    <template>
                      <v-btn
                        v-if="!retrySendSms"
                        style="text-transform:none;"
                        @click.prevent="sendCodeValidation"
                        outlined
                        color="primary"
                        :disabled="!results.isValid"
                        v-show="form.phone"
                        >Enviar código SMS</v-btn
                      >
                      <v-btn
                        @click.prevent="reSendCodeValidation"
                        v-if="retrySendSms"
                        :disabled="retrycodigoSend"
                        style="text-transform:none;"
                        outlined
                        color="primary"
                      >
                        <vue-countdown-timer
                          @start_callback="startCallBack()"
                          @end_callback="endCallBack()"
                          :start-time="'2018-10-10 00:00:00'"
                          :end-time="end_at ? end_at : endAt"
                          :interval="1000"
                          :start-label="''"
                          :end-label="''"
                          label-position="begin"
                          :end-text="'Reenviar código'"
                          :minutes-txt="'minutes'"
                          :seconds-txt="'seconds'"
                        >
                          <template slot="countdown" slot-scope="scope">
                            <span>{{ scope.props.minutes }}</span
                            >:
                            <span>{{ scope.props.seconds }}</span>
                          </template>
                        </vue-countdown-timer>
                      </v-btn>
                    </template>
                    <div style="display:flex;">
                      <form-group name="ADP">
                        <template slot-scope="{ attrs }">
                          <v-checkbox
                            color="#FB8C00"
                            v-model="PrivacityAdd"
                            v-bind="attrs"
                            @change="Revew"
                          ></v-checkbox>
                        </template>
                      </form-group>
                      <div>
                        <p class="mt-5">
                          Acepto que he leido el
                          <a
                            style="color:#FB8C00;"
                            href="/aviso-de-privacidad"
                            target="_blanck"
                            >Aviso de Privacidad</a
                          >
                        </p>
                      </div>
                    </div>
                  </form-wrapper>
                  <p class="typo__p" v-if="submitStatus === 'OK'">
                    ¡Gracias por registrase!
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'ERROR'">
                    Por favor, corrija los campos.
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'PENDING'">
                    Enviando...
                  </p>
                </form>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  style="text-transform:none;"
                  color="#9ccc3c"
                  @click.prevent="submit"
                  :disabled="this.$v.$invalid"
                >
                  <span style="color:#fff">Registrarme</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-snackbar v-model="snackbar">
          {{ snackbarText }}
          <v-btn color="blue" text @click="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
import axios from "axios";
import { mapActions } from "vuex";
import utils from "@/utils/utils";
import {
  required,
  minLength,
  email,
  numeric,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
export default {
  name: "Register",
  mounted() {
    this.makeDays();
  },
  data() {
    return {
      dia: "",
      mes: "",
      ano: "",
      dias: [],
      anos: [],
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      results: "",
      endAt: new Date().getTime() + 100000,
      pasConfirm2: false,
      pasConfirm: false,
      PrivacityAdd: false,
      form: {
        name: "",
        lastname: "",
        email: "",
        phone: "",
        codeValidation: "",
        birtdate: "",
        password: "",
        repeatPassword: "",
        DateVal: null,
        ADP: "",
      },
      retrySendSms: false,
      codigoSend: true,
      retrycodigoSend: false,
      submitStatus: null,
      minDate: "1925-01-05",
      maxDate: "2000-01-05",
      show1: false,
      fromDateMenu: false,
      snackbar: false,
      snackbarText: "",
    };
  },
  validations() {
    return {
      form: {
        name: { required, minLength: minLength(1), maxLength: maxLength(30) },
        lastname: {
          required,
          minLength: minLength(1),
          maxLength: maxLength(30),
        },
        email: { required, email },
        phone: { required },
        password: { required, minLength: minLength(8) },
        repeatPassword: { sameAs: sameAs("password") },
        ADP: { required },
        codeValidation: {
          required,
          numeric,
          minLength: minLength(6),
          maxLength: maxLength(6),
        },
      },
    };
  },
  methods: {
    ...mapActions("auth", { signup: "signup" }),
    onUpdate(payload) {
      this.results = payload;
    },
    makeDays() {
      for (let index = 1; index < 32; index++) {
        this.dias.push(String(index));
      }
      for (let index = 1961; index < 2015; index++) {
        this.anos.push(String(index));
      }
    },
    startCallBack() {
      this.retrycodigoSend = true;
    },
    endCallBack() {
      this.retrycodigoSend = false;
    },
    toLowerCas() {
      this.form.email = this.form.email.toLowerCase();
      this.$v.form.email.$touch();
    },
    keymonitor(option) {
      var id = option;
      document.getElementById(id).click();
    },
    Revew() {
      if (this.PrivacityAdd) {
        this.form.ADP = "accepted";
      } else {
        this.form.ADP = "";
      }
    },
    submit() {
      console.log(this.results.formattedNumber);
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        let username = this.form.name.replace(/\s/g, "") + utils.randomId();
        let user = {
          username,
          name: this.form.name,
          last_name: this.form.lastname,
          email: this.form.email,
          phone_number: this.results.formattedNumber,
          password: this.form.password,
          password_confirmation: this.form.repeatPassword,
          code_validation: this.form.codeValidation,
          userprofile: null,
        };

        this.signup(user)
          .then(() => {
            this.$store.state.auth.signed = true;
            this.$store.state.auth.signedMssg =
              "Para poder ingresar a Obipets, es necesario que confirmes tu cuenta de correo. \n Te pedimos revisar la bandeja de tu Email que registraste.";

            this.$router.push({
              name: "login",
            });
          })
          .catch((err) => {
            this.snackbar = true;
            if (err) {
              this.snackbarText = "Parece que el correo ya se ha utilizado.";
            }
          });
      }
    },
    sendCodeValidation() {
      console.log(this.results.formattedNumber);
      axios
        .post("/auth/generate-phone-code/", {
          phoneNumber: this.results.formattedNumber,
        })
        .then(() => {
          this.snackbar = true;
          this.snackbarText = "Código enviado a su celular";
          this.codigoSend = false;
          this.retrySendSms = true;
        })
        .catch();
    },
    reSendCodeValidation() {
      axios
        .post("/auth/second-generate-phone-code/", {
          phoneNumber: this.results.formattedNumber,
        })
        .then(() => {
          this.retrycodigoSend = true;
          this.snackbar = true;
          this.snackbarText = "Código enviado a su celular";
        })
        .catch();
    },
  },
  computed: {
    pasSucces() {
      if (this.$v.form.password.$model !== "") {
        if (this.$v.form.password.$invalid) {
          return false;
        } else {
          return true;
        }
      } else {
        return null;
      }
    },
    pasError() {
      if (this.$v.form.password.$model !== "") {
        if (this.$v.form.password.$invalid) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    pasRepSucces() {
      if (this.$v.form.repeatPassword.$model !== "") {
        if (this.$v.form.repeatPassword.$invalid) {
          return false;
        } else {
          return true;
        }
      } else {
        return null;
      }
    },
    pasRepError() {
      if (this.$v.form.repeatPassword.$model !== "") {
        if (this.$v.form.repeatPassword.$invalid) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    succesDate() {
      if (this.$v.form.DateVal.$model !== "") {
        if (this.$v.form.DateVal.$invalid) {
          return false;
        } else {
          return true;
        }
      } else {
        return null;
      }
    },
    fromDateDisp() {
      return this.form.DateVal;
      // format/do something with date
    },
    end_at() {
      return null;
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.register-frame {
  background-image: url("~@/assets/img/backgrounds/fondoazul.png");
  background-position: center center;
  background-size: cover;
}
</style>
